import toolkit from '@/app/mixins/toolkit/item';
import pension from '@/app/mixins/toolkit/pension/pension';
import { getFormattedMemberName } from '@/app/utils/utils';
import { dollar } from '@/app/filters/filters';

export default {
  name: 'minutes',
  mixins: [toolkit, pension],
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    fundName() {
      return this.fund.details.name;
    },
    listOfTrustee() {
      return this.fund.trustee.trustees;
    },
    trusteeType() {
      return this.fund.trustee.type;
    },
    formatTrusteesAsString() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`)).join(', ');
    },
    formatTrusteesAsList() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`));
    },
    formatMembers() {
      return (this.fund.members.flatMap(member => `${member.firstName} ${member.lastName}`)).join(', ');
    },
    displayPensionStartReason() {
      if (this.pension === null) {
        return '';
      }

      const reasons = {
        "The whole balance of the pensioner's accumulation account":
          'The request that the pension should commence with the full balance of the Member’s accumulation account at the time was also noted.',
        "The balance of the pensioner's accumulation account less a fixed amount": `The request that the pension should commence with the full balance of the Member’s accumulation account at the time <span class='font-bold italic'>less</span> ${dollar(
          this.pensionFixedAmount,
        )} was also noted.`,
        'As much as possible without going over the transfer balance cap':
          'The request that the pension should commence with as much as possible of the Member’s accumulation account without causing the Member to exceed the applicable Transfer Balance Cap was also noted.',
        'A fixed amount': `The request that the pension should commence with a fixed amount of ${dollar(this.pensionFixedAmount)} was also noted.`,
      };

      return reasons[this.getItem.setup.howMuch];
    },
    displayReversionaryBeneficiaryWording() {
      if (this.pension === null
        || this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === undefined) {
        return '';
      }
      let paragraph = '';
      if (this.pension.reversionaryBeneficiary.hasReversionaryBeneficiary === 'No') {
        paragraph = 'It was resolved that the pension would cease on the death of the Member.';
      } else {
        const relationship = this.pension.reversionaryBeneficiary.beneficiaryDetails.relationship
          === 'Other allowable beneficiary'
          ? this.pension.reversionaryBeneficiary.beneficiaryDetails
            .otherRelationship
          : this.pension.reversionaryBeneficiary.beneficiaryDetails.relationship;
        const person = getFormattedMemberName(
          this.pension.reversionaryBeneficiary.beneficiaryDetails,
        );
        const formattedRelationship = relationship[0].toLowerCase() + relationship.slice(1);
        paragraph = `It was resolved that the pension would automatically continue to the Member’s ${formattedRelationship}, ${person} on death as long as this is permitted by superannuation law at the time.`;
      }

      return paragraph;
    },
    displayTrustDeedClause() {
      if (this.pension === null
        || this.pension.reversionaryBeneficiary.hasTrustDeed === undefined) {
        return '';
      }
      if (this.pension.reversionaryBeneficiary.hasTrustDeed === 'Yes') {
        return 'It was resolved that any lawful reversionary arrangements would have effect automatically on the death of the Member without requiring any further action by the Trustee. It was noted that the Fund’s governing rules provide for this arrangement to override any other death benefit nominations in place.';
      }
      return '';
    },
    hasSegregation() {
      return this.pension !== null && this.pension.segregation.hasSegregation !== 'No';
    },
    hasSegregatedPensionAssets() {
      return this.pension !== null && this.pension.segregation.segregatedPensionAssets === 'Yes';
    },
    hasPensionAssets() {
      return this.pension !== null && this.pension.segregation.pensionAssets === 'Yes';
    },
  },
};
